
import { defineComponent, ref } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import MerchantFieldMapModal from "./MerchantFieldMapModal.vue";
import NewMerchantMondayModal from "./NewMerchantMondayModal.vue";
import NewMerchantAirtableModal from "./NewMerchantAirtableModal.vue";
import NewMerchantGooglesheetsModal from "./NewMerchantGooglesheetsModal.vue";
import NewMerchantExcelModal from "./NewMerchantExcelModal.vue";
import { Modal } from "bootstrap";
import { Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "merchant-import-modal",
  components: {
    MerchantFieldMapModal,
    NewMerchantAirtableModal,
    NewMerchantMondayModal,
    NewMerchantGooglesheetsModal,
    NewMerchantExcelModal,
  },
  props: {
    formType: String,
  },
  data: () => ({
    fieldMap: false,
    error: null,
    file: null,
    dataFields: null,
  }),
  methods: {
    handleCompletedImport(param) {
      this.originalData = param;
      if (this.originalData) {
        this.dataFields = this.originalData[0];
      }
      var fieldMapModal = new Modal(
        document.getElementById("kt_modal_merchant_fieldmap_" + this.formType),
        {}
      );
      fieldMapModal.show();
    },
  },
  setup() {
    const store = useStore();
    const isLoading = ref<boolean>(false);
    const isCompleted = ref<boolean>(false);
    // eslint-disable-next-line
    const originalData = ref<any[]>([]);

    const handleFieldMap = async (param) => {
      isLoading.value = true;

      if (param !== null) {
        let fieldsmap = {
          merchant_type: null,
          mid_number: null,
          customer_id: null,
          processor_id: null,
          corp_name: null,
          dba_name: null,
          tpp_id: null,
          group_id: null,
          iso_id: null,
          mid_descriptor: null,
          crm_uuid: null,
          gw_uuid: null,
          mcc: null,
          logo_url: null,
          product_name: null,
          product_description: null,
          product_url: null,
          product_price: null,
          fulfill_type: null,
          url: null,
          url_phone: null,
          email: null,
          terms_url: null,
          cancel_url: null,
          contact_url: null,
          refund_url: null,
        };

        param.forEach((group) => {
          if (group.item !== "") {
            if (originalData.value) {
              let index = originalData.value[0].findIndex(
                (header) => header === group.item
              );
              fieldsmap[group.name] = index;
            }
          }
        });

        // eslint-disable-next-line
        let data: any = [];

        originalData.value.slice(1).map((row) => {
          let arg = {};

          Object.keys(fieldsmap).forEach((headerAligned) => {
            if (headerAligned === "customer_id") {
              arg[headerAligned] = store.getters.currentUser.data.customer_id;
            } else if (headerAligned === "group_id") {
              arg[headerAligned] =
                store.getters.currentUser.data.companygroupid;
            } else {
              if (fieldsmap[headerAligned] !== null) {
                if (row[fieldsmap[headerAligned]]) {
                  arg[headerAligned] = row[fieldsmap[headerAligned]];
                } else {
                  arg[headerAligned] = "";
                }
              } else {
                arg[headerAligned] = "";
              }
            }
          });

          data.push(arg);
        });

        try {
          const res = await ApiService.post(
            "merchants/queue?action=insert_merchant",
            data
          );

          if (res.status == 201 && res.data.success) {
            Swal.fire({
              text: "You have successfully created the merchant!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(async function () {
              await ApiService.put(
                `customers/accounts/${store.getters.currentUser.data.customer_id}?flag=0&welcome_flag=0`,
                {}
              );
              await store.dispatch(Actions.VERIFY_AUTH, {
                token: JwtService.getToken(),
              });
              isCompleted.value = true;
            });
          } else {
            Swal.fire({
              text: res.data.data.error
                ? res.data.data.error[0]
                : "Something went wrong!",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Try again!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          }
        } catch (e) {
          Swal.fire({
            text: e.response.data.error
              ? e.response.data.error.message
              : "Something went wrong!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      }

      isLoading.value = false;
    };

    return {
      originalData,
      isLoading,
      isCompleted,
      handleFieldMap,
    };
  },
});
